import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import LayoutWrapper from './Layout/LayoutWrapper'
import LoginPage from '../containers/Auth/LoginPage'
import OTPPage from '../containers/Auth/OTPPage'
import ForgotPassword from '../containers/Auth/ForgotPassword'
import Dashboard from '../containers/Dashboard/Dashboard'
import FundManagementDashboard from '../containers/fund-management/FundManagementDashboard'
import UserManagementDashboard from '../containers/user-management/UserManagementDashboard'

const AppRouter = () => {
    const { isAuthenticated } = useSelector((state) => state.auth)

    if (!isAuthenticated) {
        return (
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/verify-otp" element={<OTPPage />} />
                <Route path="/reset-password" element={<ForgotPassword />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        )
    }

    return (
        <Routes>
            <Route element={<LayoutWrapper />}>
                <Route path="/" element={<Navigate to="/profile" replace />} />
                <Route path="/profile" element={<Dashboard />} />
                <Route path="/account" element={<FundManagementDashboard />} />
                <Route path="/users" element={<UserManagementDashboard />} />
                <Route path="/login" element={<Navigate to="/profile" replace />} />
                <Route path="*" element={<Navigate to="/profile" replace />} />
            </Route>
        </Routes>
    )
}

export default AppRouter